export default __webpack_public_path__ + "static/media/jcb.b59a5ebd.svg";